import { render, staticRenderFns } from "./EvDrawerContent.vue?vue&type=template&id=e5127c76&lang=pug"
import script from "./EvDrawerContent.vue?vue&type=script&lang=js"
export * from "./EvDrawerContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports